import request from '@/api/config/request'

const prex = "api/admin/pessoas/";

export function listEmpresas(query = {}) {
    return request({
        url: `${prex}empresas`,
        method: 'get',
        params: query
    })
}

export function listUsuarios(query = {}) {
    return request({
        url: `${prex}usuarios`,
        method: 'get',
        params: query
    })
}

export function getPesquisaUsuario(cpfcnpj) {
    return request({
        url: `${prex}usuarios/cpfcnpj/${cpfcnpj}`,
        method: 'get'
    })
}

export function getUsuario(aut_hash) {
    return request({
        url: `${prex}usuarios/${aut_hash}`,
        method: 'get'
    })
}

export function getUsuarioTemp(tus_codigo) {
    return request({
        url: `${prex}usuarios/temp/${tus_codigo}`,
        method: 'get'
    })
}

export function saveUsuario(data) {
    return request({
        url: `${prex}/usuarios`,
        method: 'post',
        data
    })
}

export function saveUsuarioTemp(data) {
    return request({
        url: `${prex}/usuarios/temp`,
        method: 'post',
        data
    })
}

export function deleteUsuarioTemp(tus_codigo) {
    return request({
        url: `${prex}usuarios/temp/${tus_codigo}`,
        method: 'delete'
    })
}